import { render, staticRenderFns } from "./SchoolLmsAnalytics.vue?vue&type=template&id=8dc9ccf2&scoped=true&"
import script from "./SchoolLmsAnalytics.vue?vue&type=script&lang=js&"
export * from "./SchoolLmsAnalytics.vue?vue&type=script&lang=js&"
import style0 from "./SchoolLmsAnalytics.vue?vue&type=style&index=0&id=8dc9ccf2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc9ccf2",
  null
  
)

export default component.exports